/**
 * LockedIn photoreal sport marks — neon-ring equipment medallions.
 * Custom generated assets (no team/league logos). Prefer these over flat SVGs
 * on hero surfaces; SportIcon glyphs stay for compact inline chrome.
 */
import baseball from './marks/baseball.png';
import basketball from './marks/basketball.png';
import football from './marks/football.png';
import soccer from './marks/soccer.png';
import hockey from './marks/hockey.png';
import boxing from './marks/boxing.png';
import mma from './marks/mma.png';
import college from './marks/college.png';
import generic from './marks/generic.png';

export const SPORT_MARK_IMAGES = Object.freeze({
  baseball,
  basketball,
  football,
  soccer,
  hockey,
  boxing,
  mma,
  college,
  /** All-games shelf — multi-ball cluster (not the college cap). */
  generic,
});

export function getSportMarkImage(iconId) {
  return SPORT_MARK_IMAGES[iconId] || SPORT_MARK_IMAGES.generic;
}
